'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = omitProperty;
function omitProperty(name) {
  return name.startsWith('__') || name.startsWith('STORYBOOK_');
}


//////////////////
// WEBPACK FOOTER
// ./~/@storybook/addon-actions/dist/lib/util/omitProperty.js
// module id = 1006
// module chunks = 0